<div class="employee-profile-page" [ngClass]="employeeColorClass">
  <div class="toast show" *ngIf="toastMessage" [class.success]="toastKind === 'success'"
    [class.error]="toastKind === 'error'" [class.warning]="toastKind === 'info'" (click)="clearToast()" role="status"
    aria-live="polite">
    <img class="icon"
      [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'" alt=""
      aria-hidden="true" />

    <div class="toast-title">
      {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
    </div>

    <div class="toast-body">{{ toastMessage }}</div>
  </div>

  <div class="delete-modal-backdrop" *ngIf="isDeleteModalOpen">
    <div class="delete-modal" role="dialog" aria-modal="true">
      <h3>Delete User</h3>

      <p>
        Are you sure you want to delete
        <strong>{{ employee?.firstName || '-' }} {{ employee?.lastName || '-' }}</strong>?
        This action cannot be undone.
      </p>

      <div class="delete-error" *ngIf="deleteError">
        {{ deleteError }}
      </div>

      <div class="delete-modal-actions">
        <button type="button" class="btn-secondary" (click)="closeDeleteModal()" [disabled]="isDeleting">
          Cancel
        </button>

        <button type="button" class="btn-danger" (click)="confirmDeleteUser()" [disabled]="isDeleting">
          {{ isDeleting ? 'Deleting...' : 'Delete User' }}
        </button>
      </div>
    </div>
  </div>


  <!-- Add Assigned WONs Modal -->
  <div
    class="won-modal-backdrop"
    *ngIf="isAddWonsModalOpen"
    (click)="closeAddWonsModal()"
  >
    <div
      class="won-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="addWonsTitle"
      (click)="$event.stopPropagation()"
    >
      <div class="won-modal-header">
        <div>
          <h3 id="addWonsTitle">Add Assigned WONs</h3>
          <p>Select one or more work orders to assign to this employee.</p>
        </div>

        <button
          type="button"
          class="icon-btn modal-close-btn"
          aria-label="Close add work orders modal"
          (click)="closeAddWonsModal()"
          [disabled]="isAddingWons"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>

      <div class="won-modal-search">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="11" cy="11" r="7" />
          <path d="m20 20-3.5-3.5" />
        </svg>

        <input
          type="search"
          [(ngModel)]="wonSearchTerm"
          placeholder="Search WON, description, project, or department"
          [disabled]="isAddingWons"
        />
      </div>

      <div class="won-modal-summary">
        <span>{{ availableWorkOrders.length }} available</span>
        <strong>{{ selectedWorkOrderCount }} selected</strong>
      </div>

      <div class="won-selection-list" *ngIf="availableWorkOrders.length; else noAvailableWons">
        <button
          type="button"
          class="won-selection-row"
          *ngFor="let workOrder of availableWorkOrders"
          [class.selected]="isWorkOrderSelected(workOrder.id)"
          (click)="toggleWorkOrderSelection(workOrder.id)"
          [disabled]="isAddingWons"
        >
          <span class="won-checkbox" aria-hidden="true">
            <svg *ngIf="isWorkOrderSelected(workOrder.id)" viewBox="0 0 24 24">
              <path d="m5 12 4 4L19 6" />
            </svg>
          </span>

          <span class="won-selection-copy">
            <span class="won-selection-title-row">
              <strong>{{ workOrder.won }}</strong>

              <span class="won-type-pill" [class.overhead]="workOrder.isOverhead">
                {{ workOrder.isOverhead ? 'Overhead' : 'Standard' }}
              </span>
            </span>

            <span class="won-selection-description">
              {{ workOrder.description || 'No description' }}
            </span>

            <span class="won-selection-meta">
              <span *ngIf="workOrder.project?.name">
                Project: {{ workOrder.project?.name }}
              </span>
              <span *ngIf="workOrder.department">
                Dept: {{ workOrder.department?.code }} — {{ workOrder.department?.name }}
              </span>
            </span>
          </span>
        </button>
      </div>

      <ng-template #noAvailableWons>
        <div class="won-empty-state">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="M8 9h8" />
            <path d="M8 13h5" />
          </svg>

          <strong>No work orders available</strong>
          <span>
            {{
              wonSearchTerm
                ? 'No work orders match your search.'
                : 'All work orders are already assigned.'
            }}
          </span>
        </div>
      </ng-template>

      <div class="won-modal-error" *ngIf="addWonsError">
        {{ addWonsError }}
      </div>

      <div class="won-modal-actions">
        <button
          type="button"
          class="btn-secondary"
          (click)="closeAddWonsModal()"
          [disabled]="isAddingWons"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn-primary"
          (click)="openAddWonsConfirmModal()"
          [disabled]="isAddingWons || selectedWorkOrderCount === 0"
        >
          {{
            isAddingWons
              ? 'Adding...'
              : 'Review ' + selectedWorkOrderCount + ' WON' + (selectedWorkOrderCount === 1 ? '' : 's')
          }}
        </button>
      </div>
    </div>
  </div>


  <!-- Confirm Add Assigned WONs -->
  <div
    class="confirmation-modal-backdrop"
    *ngIf="isAddWonsConfirmModalOpen"
  >
    <div
      class="confirmation-modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirmAddWonsTitle"
      aria-describedby="confirmAddWonsDescription"
    >
      <div class="confirmation-icon add" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M12 5v14" />
          <path d="M5 12h14" />
        </svg>
      </div>

      <h3 id="confirmAddWonsTitle">Assign selected WONs?</h3>

      <p id="confirmAddWonsDescription">
        You are about to assign
        <strong>{{ selectedWorkOrderCount }}</strong>
        work order{{ selectedWorkOrderCount === 1 ? '' : 's' }}
        to {{ employee?.firstName || 'this employee' }}.
      </p>

      <div class="confirmation-won-list">
        <div *ngFor="let workOrder of selectedWorkOrders">
          <strong>{{ workOrder.won }}</strong>
          <span>{{ workOrder.description || 'No description' }}</span>
        </div>
      </div>

      <div class="confirmation-modal-actions">
        <button
          type="button"
          class="btn-secondary"
          (click)="closeAddWonsConfirmModal()"
          [disabled]="isAddingWons"
        >
          Go Back
        </button>

        <button
          type="button"
          class="btn-primary"
          (click)="confirmAddSelectedWorkOrders()"
          [disabled]="isAddingWons"
        >
          {{ isAddingWons ? 'Adding...' : 'Confirm Add' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Confirm Delete Assigned WON -->
  <div
    class="confirmation-modal-backdrop"
    *ngIf="isDeleteWonConfirmModalOpen && pendingDeleteWorkOrder"
  >
    <div
      class="confirmation-modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirmDeleteWonTitle"
      aria-describedby="confirmDeleteWonDescription"
    >
      <div class="confirmation-icon danger" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M3 6h18" />
          <path d="M8 6V4h8v2" />
          <path d="M19 6 18 20H6L5 6" />
          <path d="M10 11v5" />
          <path d="M14 11v5" />
        </svg>
      </div>

      <h3 id="confirmDeleteWonTitle">Remove assigned WON?</h3>

      <p id="confirmDeleteWonDescription">
        Remove
        <strong>{{ pendingDeleteWorkOrder.workOrderNumber.won }}</strong>
        from {{ employee?.firstName || 'this employee' }}?
      </p>

      <div class="confirmation-single-won">
        <strong>{{ pendingDeleteWorkOrder.workOrderNumber.won }}</strong>
        <span>
          {{ pendingDeleteWorkOrder.workOrderNumber.description || 'No description' }}
        </span>
      </div>

      <div class="confirmation-modal-actions">
        <button
          type="button"
          class="btn-secondary"
          (click)="closeDeleteWonConfirmModal()"
          [disabled]="deletingWorkOrderNumberId !== null"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn-danger"
          (click)="confirmDeleteAssignedWorkOrder()"
          [disabled]="deletingWorkOrderNumberId !== null"
        >
          {{
            deletingWorkOrderNumberId !== null
              ? 'Removing...'
              : 'Remove WON'
          }}
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isLoading; else content">
    <div class="loading-overlay">
      <div class="spinner"></div>
    </div>
  </ng-container>

  <ng-template #content>
    <ng-container *ngIf="employee && form; else errorTpl">
      <main class="profile-shell">
        <button type="button" class="back-btn" (click)="goBack()">
          ← Back to Employees
        </button>

        <section class="profile-hero-card">
          <div class="hero-left">
            <div class="profile-avatar">
              {{ employee.firstName[0] || '?' }}{{ employee.lastName[0] || '?' }}
            </div>

            <div class="hero-copy">
              <div class="eyebrow">Employee Profile</div>
              <h1>{{ employee.firstName || '-' }} {{ employee.lastName || '-' }}</h1>

              <div class="hero-meta">
                <span>Employee #{{ employee.employeeNumber || '-' }}</span>
                <span>•</span>
                <span>{{ employee.department?.name || 'No Department' }}</span>
                <span>•</span>
                <span>{{ employee.company?.name || 'No Company' }}</span>
              </div>
            </div>
          </div>

          <div class="hero-right">
            <span class="status-pill" [ngClass]="getStatusClass(form.status)">
              <span class="status-dot"></span>
              {{ form.status }}
            </span>

            <button type="button" class="btn-danger subtle" (click)="openDeleteModal()"
              [disabled]="isDeleting || isSaving">
              Delete User
            </button>
          </div>
        </section>

        <div class="edit-bar" *ngIf="isDirty">
          <div>
            <strong>Unsaved changes</strong>
            <span *ngIf="saveError">{{ saveError }}</span>
          </div>

          <div class="edit-actions">
            <button type="button" class="btn-secondary" (click)="cancelChanges()" [disabled]="isSaving">
              Cancel
            </button>

            <button type="button" class="btn-primary" (click)="saveChanges()" [disabled]="isSaving">
              {{ isSaving ? 'Saving...' : 'Save Changes' }}
            </button>
          </div>
        </div>

        <section class="profile-tabs-card">
          <button type="button" class="profile-tab" [class.active]="activeTab === 'Contact'"
            [class.tab-missing]="hasMissingRequiredData('Contact')" (click)="activeTab = 'Contact'">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20 21a8 8 0 0 0-16 0" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            Contact
          </button>

          <button type="button" class="profile-tab" [class.active]="activeTab === 'Work'"
            [class.tab-missing]="hasMissingRequiredData('Work')" (click)="activeTab = 'Work'">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="7" width="18" height="14" rx="2" />
              <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
              <path d="M12 12v3" />
            </svg>
            Work
          </button>

          <button type="button" class="profile-tab" [class.active]="activeTab === 'Schedule'"
            [class.tab-missing]="hasNoSchedule()" (click)="activeTab = 'Schedule'">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <path d="M16 2v4" />
              <path d="M8 2v4" />
              <path d="M3 10h18" />
            </svg>
            Schedule
          </button>

          <button type="button" class="profile-tab" [class.active]="activeTab === 'Reports'"
            [class.tab-missing]="hasMissingRequiredData('Reports')" (click)="activeTab = 'Reports'">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            Reports
          </button>
        </section>

        <section class="profile-content-grid single">
          <div class="profile-main-card">
            <ng-container *ngIf="activeTab === 'Contact'">
              <div class="section-header">
                <div>
                  <h2>Contact Information</h2>
                  <p>Manage identity, login, contact details, and account status.</p>
                </div>
              </div>

              <div class="missing-summary" *ngIf="hasMissingRequiredData('Contact')">
                Missing required fields:
                {{ getMissingFieldLabelsForTab('Contact').join(', ') }}
              </div>

              <div class="form-grid">
                <label class="form-field">
                  <span>Username</span>
                  <input class="text-input" type="text" [(ngModel)]="form.username" disabled />
                </label>

                <label class="form-field" [class.missing-field]="isMissingRequiredField('email')">
                  <span>Email</span>
                  <input class="text-input" type="email" [(ngModel)]="form.email" />
                  <small *ngIf="isMissingRequiredField('email')">Email is required.</small>
                </label>

                <label class="form-field" [class.missing-field]="isMissingRequiredField('firstName')">
                  <span>First Name</span>
                  <input class="text-input" type="text" [(ngModel)]="form.firstName" />
                  <small *ngIf="isMissingRequiredField('firstName')">First name is required.</small>
                </label>

                <label class="form-field" [class.missing-field]="isMissingRequiredField('lastName')">
                  <span>Last Name</span>
                  <input class="text-input" type="text" [(ngModel)]="form.lastName" />
                  <small *ngIf="isMissingRequiredField('lastName')">Last name is required.</small>
                </label>

                <label class="form-field" [class.missing-field]="isMissingRequiredField('rfid')">
                  <span>RFID</span>
                  <input class="text-input" type="text" [(ngModel)]="form.rfid" />
                  <small *ngIf="isMissingRequiredField('rfid')">RFID is required.</small>
                </label>

                <label class="form-field" [class.missing-field]="isMissingRequiredField('employeeNumber')">
                  <span>Employee #</span>
                  <input class="text-input" type="text" [(ngModel)]="form.employeeNumber" />
                  <small *ngIf="isMissingRequiredField('employeeNumber')">Employee number is required.</small>
                </label>

                <div class="form-field full phone-field"
                  [class.missing-field]="isMissingRequiredField('phoneLocalNumber')">
                  <span>Phone</span>

                  <div class="phone-input-row">
                    <app-search-select [options]="countryPhoneCodeOptions" placeholder="Search country..."
                      [(selectedId)]="form.phoneCountryIso2" (selectedIdChange)="onPhoneCountryChange($event)">
                    </app-search-select>

                    <input class="text-input" type="tel" inputmode="numeric" autocomplete="tel-national"
                      placeholder="(555) 123-4567" [value]="getPhoneLocalInputValue()"
                      (input)="onPhoneLocalNumberInput(($any($event.target).value))" />
                  </div>

                  <small *ngIf="isMissingRequiredField('phoneLocalNumber')">Phone is required.</small>
                </div>

                <label class="form-field">
                  <span>Admin Access</span>
                  <select class="select-input" [(ngModel)]="form.adminAccess" [disabled]="isSaving">
                    <option *ngFor="let option of adminAccessOptions" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </label>

                <div class="form-field toggle-field">
                  <span>Auto Booking</span>

                  <label class="ios-toggle">
                    <input type="checkbox" [(ngModel)]="form.enableAutoBooking" [disabled]="isSaving" />
                    <span class="toggle-track">
                      <span class="toggle-thumb"></span>
                    </span>
                    <strong>{{ form.enableAutoBooking ? 'On' : 'Off' }}</strong>
                  </label>
                </div>

                <label class="form-field">
                  <span>Status</span>
                  <select class="select-input" [(ngModel)]="form.status" [ngClass]="getStatusClass(form.status)">
                    <option *ngFor="let s of statusOptions" [ngValue]="s">{{ s }}</option>
                  </select>
                </label>

                <div class="form-field" [class.missing-field]="isMissingRequiredField('reportToId')">
                  <span>Reports To</span>
                  <app-search-select [options]="reportToOptions" placeholder="Search employees..."
                    [(selectedId)]="form.reportToId" [invalid]="isMissingRequiredField('reportToId')">
                  </app-search-select>
                  <small *ngIf="isMissingRequiredField('reportToId')">Reports To is required.</small>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="activeTab === 'Work'">
              <div class="section-header">
                <div>
                  <h2>Work Information</h2>
                  <p>Manage organization, payroll, shift, and default work assignment setup.</p>
                </div>
              </div>

              <div class="missing-summary" *ngIf="hasMissingRequiredData('Work')">
                Missing required fields:
                {{ getMissingFieldLabelsForTab('Work').join(', ') }}
              </div>

              <div class="form-grid">
                <div class="form-field" [class.missing-field]="isMissingRequiredField('companyId')">
                  <span>Company</span>
                  <app-search-select [options]="companyOptions" placeholder="Search companies..."
                    [(selectedId)]="form.companyId" [invalid]="isMissingRequiredField('companyId')"></app-search-select>
                  <small *ngIf="isMissingRequiredField('companyId')">Company is required.</small>
                </div>

                <div class="form-field" [class.missing-field]="isMissingRequiredField('departmentId')">
                  <span>Department</span>
                  <app-search-select [options]="departmentOptions" placeholder="Search departments..."
                    [(selectedId)]="form.departmentId"
                    [invalid]="isMissingRequiredField('departmentId')"></app-search-select>
                  <small *ngIf="isMissingRequiredField('departmentId')">Department is required.</small>
                </div>

                <div class="form-field" [class.missing-field]="isMissingRequiredField('workerTypeId')">
                  <span>Worker Type</span>
                  <app-search-select [options]="workerTypeOptions" placeholder="Search worker types..."
                    [(selectedId)]="form.workerTypeId"
                    [invalid]="isMissingRequiredField('workerTypeId')"></app-search-select>
                  <small *ngIf="isMissingRequiredField('workerTypeId')">Worker type is required.</small>
                </div>

                <div class="form-field" [class.missing-field]="isMissingRequiredField('payGroupId')">
                  <span>Pay Group</span>
                  <app-search-select [options]="payGroupOptions" placeholder="Search pay groups..."
                    [(selectedId)]="form.payGroupId"
                    [invalid]="isMissingRequiredField('payGroupId')"></app-search-select>
                  <small *ngIf="isMissingRequiredField('payGroupId')">Pay group is required.</small>
                </div>

                <div class="form-field" [class.missing-field]="isMissingRequiredField('defaultWorkOrderNumberId')">
                  <span>Default Overhead WON</span>
                  <app-search-select [options]="overheadWonOptions" placeholder="Search overhead work orders..."
                    [(selectedId)]="form.defaultWorkOrderNumberId"
                    [invalid]="isMissingRequiredField('defaultWorkOrderNumberId')"></app-search-select>
                  <small *ngIf="isMissingRequiredField('defaultWorkOrderNumberId')">Default overhead WON is
                    required.</small>
                </div>

                <div class="form-field" [class.missing-field]="isMissingRequiredField('shiftId')">
                  <span>Shift</span>
                  <app-search-select [options]="shiftOptions" placeholder="Search shifts..."
                    [(selectedId)]="form.shiftId" [invalid]="isMissingRequiredField('shiftId')"></app-search-select>
                  <small *ngIf="isMissingRequiredField('shiftId')">Shift is required.</small>
                </div>
              </div>


              <!-- Assigned WONs -->
              <section class="assigned-wons-section">
                <div class="assigned-wons-header">
                  <div>
                    <h3>Assigned WONs</h3>
                    <p>
                      Work orders this employee can book time against.
                    </p>
                  </div>

                  <button
                    type="button"
                    class="add-won-btn"
                    (click)="openAddWonsModal()"
                    [disabled]="isAddingWons || availableWorkOrders.length === 0"
                  >
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M12 5v14" />
                      <path d="M5 12h14" />
                    </svg>
                    Add WONs
                  </button>
                </div>

                <div class="assigned-wons-list" *ngIf="assignedWorkOrders.length; else noAssignedWons">
                  <div class="assigned-won-row" *ngFor="let assignment of assignedWorkOrders">
                    <div class="assigned-won-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24">
                        <rect x="3" y="5" width="18" height="14" rx="2" />
                        <path d="M8 9h8" />
                        <path d="M8 13h5" />
                      </svg>
                    </div>

                    <div class="assigned-won-info">
                      <div class="assigned-won-title-row">
                        <strong>{{ assignment.workOrderNumber.won }}</strong>
                      </div>

                      <span class="assigned-won-description">
                        {{ assignment.workOrderNumber.description || 'No description' }}
                      </span>
                    </div>

                    <button
                      type="button"
                      class="delete-won-btn"
                      [attr.aria-label]="'Remove ' + assignment.workOrderNumber.won"
                      [title]="'Remove ' + assignment.workOrderNumber.won"
                      (click)="openDeleteWonConfirmModal(assignment)"
                      [disabled]="deletingWorkOrderNumberId !== null"
                    >
                      <span
                        class="mini-spinner"
                        *ngIf="deletingWorkOrderNumberId === assignment.workOrderNumber.id"
                        aria-hidden="true"
                      ></span>

                      <svg
                        *ngIf="deletingWorkOrderNumberId !== assignment.workOrderNumber.id"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <path d="M3 6h18" />
                        <path d="M8 6V4h8v2" />
                        <path d="M19 6 18 20H6L5 6" />
                        <path d="M10 11v5" />
                        <path d="M14 11v5" />
                      </svg>
                    </button>
                  </div>
                </div>

                <ng-template #noAssignedWons>
                  <div class="assigned-wons-empty">
                    <span>No assigned WONs</span>
                    <button type="button" (click)="openAddWonsModal()">
                      Add the first WON
                    </button>
                  </div>
                </ng-template>
              </section>

              <div class="policy-grid">
                <div class="leave-balance-card vacation"
                  [class.missing-field]="isMissingRequiredField('vacationLeavePolicy')">
                  <div>
                    <span>Vacation Policy</span>
                    <strong>{{ getLeavePolicyDisplay(employee.vacationLeavePolicy) }}</strong>
                  </div>

                  <div class="leave-hours">
                    {{ vacationLeaveBalanceDisplay }}
                  </div>

                  <small>Used: {{ vacationLeaveUsedDisplay }}</small>
                </div>

                <div class="leave-balance-card sick" [class.missing-field]="isMissingRequiredField('sickLeavePolicy')">
                  <div>
                    <span>Sick Policy</span>
                    <strong>{{ getLeavePolicyDisplay(employee.sickLeavePolicy) }}</strong>
                  </div>

                  <div class="leave-hours">
                    {{ sickLeaveBalanceDisplay }}
                  </div>

                  <small>Used: {{ sickLeaveUsedDisplay }}</small>
                </div>
              </div>

              <div class="audit-grid">
                <div>
                  <span>Created At</span>
                  <strong>{{ employee.createdAt | date: 'medium' }}</strong>
                </div>

                <div *ngIf="employee.createdBy">
                  <span>Created By</span>
                  <strong>{{ employee.createdBy.firstName }} {{ employee.createdBy.lastName }}</strong>
                </div>

                <div *ngIf="employee.updatedAt">
                  <span>Updated At</span>
                  <strong>{{ employee.updatedAt | date: 'medium' }}</strong>
                </div>

                <div *ngIf="employee.updatedBy">
                  <span>Updated By</span>
                  <strong>{{ employee.updatedBy.firstName }} {{ employee.updatedBy.lastName }}</strong>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="activeTab === 'Schedule'">
              <div class="section-header">
                <div>
                  <h2>Weekly Schedule</h2>
                  <p>Review schedule group and weekly assigned hours.</p>
                </div>
              </div>

              <div class="missing-summary" *ngIf="hasNoSchedule()">
                Missing required fields: Schedule
              </div>

              <div class="schedule-summary-grid">
                <div>
                  <span>Schedule Group</span>
                  <strong>{{ employee.departmentScheduleGroup?.scheduleGroup?.name || '-' }}</strong>
                </div>

                <div>
                  <span>Schedule Department</span>
                  <strong>{{ employee.departmentScheduleGroup?.department?.name || '-' }}</strong>
                </div>
              </div>

              <div class="schedule-list" *ngIf="getScheduleRows().length; else noSchedule">
                <div class="schedule-item" *ngFor="let s of getScheduleRows()" [class.today]="s.isToday">
                  <span class="day">{{ s.dayOfWeek }}</span>
                  <span class="time">{{ s.startTime }} - {{ s.endTime }}</span>
                </div>
              </div>

              <ng-template #noSchedule>
                <div class="empty-state">No schedules available</div>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="activeTab === 'Reports'">
              <div class="section-header">
                <div>
                  <h2>Reports</h2>
                  <p>Review roles and direct reports assigned to this employee.</p>
                </div>
              </div>

              <div class="report-stats">
                <div>
                  <span>Roles</span>
                  <strong>{{ employee.roles.length || 0 }}</strong>
                </div>

                <div>
                  <span>Direct Reports</span>
                  <strong>{{ employee.employees.length || 0 }}</strong>
                </div>
              </div>

              <div class="direct-report-row clickable" *ngFor="let e of employee.employees"
                [ngClass]="getEmployeeColorClassById(e.id, e.employeeNumber)" (click)="openEmployeeProfile(e.id)">
                <div class="mini-avatar" [ngClass]="getEmployeeColorClassById(e.id, e.employeeNumber)">
                  {{ e.firstName?.[0] || '?' }}{{ e.lastName?.[0] || '?' }}
                </div>

                <div class="direct-report-info">
                  <span>{{ e.firstName }} {{ e.lastName }}</span>
                  <strong>ID: {{ e.id }}</strong>
                </div>
              </div>
            </ng-container>
          </div>
        </section>
      </main>
    </ng-container>
  </ng-template>

  <ng-template #errorTpl>
    <main class="profile-shell">
      <button class="back-btn" type="button" (click)="goBack()">← Back to Employees</button>
      <div class="error-message">{{ errorMessage || 'Employee not found' }}</div>
    </main>
  </ng-template>
</div>